import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/landing';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-ink px-5 py-16 md:py-24" data-id="element-98" data-mp="1223hh69aexzq">
      <div className="mx-auto max-w-3xl" data-id="element-99" data-mp="122vdujapkzr2">
        <SectionHeading title="Lo que más nos preguntan" data-id="element-100" data-mp="1pro1ztl3a3b4" />
        <ul className="mt-12 space-y-3" data-id="element-101" data-mp="1pual8qhce796">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.question} className="overflow-hidden rounded-2xl border border-line bg-surface" data-id="element-102" data-mp="1ut557vr1q1uv" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left text-base font-bold text-heading transition-colors duration-150 ease-out hover:text-success focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-success md:text-lg" data-id="element-103" data-mp="1l1hfbza50svi">
                  {f.question}
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-line bg-ink transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-104" data-mp="2js70ldyth5om">
                    <PlusIcon className="h-4 w-4 text-success" strokeWidth={3} aria-hidden="true" data-id="element-105" data-mp="2toabb87qicn6" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-106" data-mp="37ijjfjvlomtz">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-107" data-mp="32h3wfm9v468y">
                      <p className="px-6 pb-6 text-base leading-relaxed text-body" data-id="element-108" data-mp="1i3d09s2q189s">{f.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}